(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-game-guide/assets/javascripts/route-play-game-guide.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-game-guide/assets/javascripts/route-play-game-guide.js');
"use strict";

const {
  SideNavResize
} = svs.components.tipsen.sideNavResize;
const {
  useBranding
} = svs.components.tipsen.hooks;
const {
  GameGuideTipsen
} = svs.components.tipsen.gameGuideTipsen;
const RoutePlayGameGuide = _ref => {
  let {
    className
  } = _ref;
  const [productBranding] = useBranding();
  const classNames = [className, 'pg_game_guide'];
  if (productBranding) {
    classNames.push("pg_game_guide_".concat(productBranding, "--padding-fix"));
  }
  return React.createElement("div", {
    className: classNames.join(' ')
  }, React.createElement(SideNavResize, null, React.createElement(GameGuideTipsen, null)));
};
setGlobal('svs.components.tipsen.routePlayGameGuide.RoutePlayGameGuide', RoutePlayGameGuide);

 })(window);